module.exports = __webpack_public_path__ + "img/icon-ywqn-item-2.33a2b5e2.png";